/** Filename of the PDF captured when a purchase order is issued. */
export const ISSUED_PO_FILENAME = "issued-po.pdf";

export function isStoredIssuedPurchaseOrder(att: {
  kind: string;
  original_filename: string;
}): boolean {
  return att.kind === "other" && att.original_filename === ISSUED_PO_FILENAME;
}
